module.exports = __webpack_public_path__ + "img/block_7_green_pin.2b19a5e2.png";